import { IItem } from '../models/IItem'

export enum QuotaAllocationMode {
  Balanced = 0,
  NonBalanced= 1,
  MaxNonBalanced = 2,
  MaximumBalanced = 3
}

export const QuotaAllocationModeList: IItem[] = [
  { id: QuotaAllocationMode.Balanced, name: "Balanced", label:"Balanced"},
  { id: QuotaAllocationMode.NonBalanced, name: "NonBalanced", label:"Not balanced"},
  { id: QuotaAllocationMode.MaxNonBalanced, name: "MaxNonBalanced", label: "Max not balanced" },
  { id: QuotaAllocationMode.MaximumBalanced, name: "MaximumBalanced", label: "Max balanced" },
];

export function QuotaAllocationModeById(mode: QuotaAllocationMode): IItem{
  for (var qm of QuotaAllocationModeList) {
    if (qm.id == mode)
      return qm;
  }
  return QuotaAllocationModeList[2];
}

export function QuotaAllocationModeByName(name: string): IItem {
  for (var qm of QuotaAllocationModeList) {
    if (qm.name == name)
      return qm;
  }
  return QuotaAllocationModeList[2];
}



// WEBPACK FOOTER //
// ./src/app/enums/quota-allocation-mode.enum.ts